import React from 'react'
import { Modal } from 'react-bootstrap'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'


export default React.createClass({

  render: function () {
    let show =[];
    let icon;
    let imgsrc;
    if(this.props.data.length > 1){
        for(let i = 0; i < this.props.data.length; i++){
          icon = (getTaskTypeIconParser(this.props.data[i].data.taskType))
          imgsrc = '/styleguide/assets/img/task-icons/circle/' + icon.iconsrc + '-circle.png'
          show.push(
            <div key={'h' + i} className='col-xs-4 pull-down-xs-2'>
              <img role="presentation"key={i} className='clickable' onClick={() => this.props.open(this.props.data[i].data)} style={{width: 60, height: 60}} src={imgsrc}/>
            </div>
            );
        }
      }
      else if(this.props.data.length === 1){
          icon = (getTaskTypeIconParser(this.props.data[0].data.taskType))
          imgsrc = '/styleguide/assets/img/task-icons/circle/' + icon.iconsrc + '-circle.png'
          show.push(
             <div key={'h' + 0} className='col-xs-4 pull-down-xs-2'>
                <img role="presentation" key={0} className='clickable' onClick={() => this.props.open(this.props.data[0].data)} style={{width: 60, height: 60}} src={imgsrc}/>
             </div>)
      }


    return (

      <div>
        <Modal show={this.props.show} onHide={this.props.hide}>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
              <h5>Select a task for this day</h5>
              <div className='row' style={{textAlign: 'center', width: '80%'}}>
                {show}
              </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/task-options-modal.jsx